module.exports = __webpack_public_path__ + "img/footer_bg.9822628a.png";